exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".src-sp-components-atoms-Icon-___Icon__darkgray___2zNyF {\n  fill: #3F4B40;\n}\n\n.src-sp-components-atoms-Icon-___Icon__white___2kblr {\n  fill: #FFF;\n}\n\n.src-sp-components-atoms-Icon-___Icon__accent___2kdm- {\n  fill: #50e6a7;\n}\n\n.src-sp-components-atoms-Icon-___Icon__gold___2wut5 {\n  fill: #FFCF21;\n}\n\n.src-sp-components-atoms-Icon-___Icon__silver___2etEw {\n  fill: #B1B8C7;\n}\n\n.src-sp-components-atoms-Icon-___Icon__bronze___1czq_ {\n  fill: #D69B00;\n}\n", ""]);

// exports
exports.locals = {
	"darkgray": "src-sp-components-atoms-Icon-___Icon__darkgray___2zNyF",
	"white": "src-sp-components-atoms-Icon-___Icon__white___2kblr",
	"accent": "src-sp-components-atoms-Icon-___Icon__accent___2kdm-",
	"gold": "src-sp-components-atoms-Icon-___Icon__gold___2wut5",
	"silver": "src-sp-components-atoms-Icon-___Icon__silver___2etEw",
	"bronze": "src-sp-components-atoms-Icon-___Icon__bronze___1czq_"
};